import { ApiType } from "@gymflow/common";
import { utcToZonedTime } from "@gymflow/helpers";
import { LeadReportItemDTO, OpenLeadReportDTO } from "@gymflow/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import merge from "lodash/merge";

import { defaultPage } from "../defaultPage";
import { reportQueryKeys } from "./reportQueryKeys";

export interface UseOpenLeadReportProps {
  api: ApiType;
  leadStatusList?: string[];
  leadSourceList?: number[];
  page?: number;
  limit?: number;
  sort?: any;
  tz: string;
}

export function useOpenLeadReport(
  {
    api,
    leadStatusList,
    leadSourceList,
    page,
    limit,
    sort,
    tz,
  }: UseOpenLeadReportProps,
  queryOpts?: Omit<UseQueryOptions<OpenLeadReportDTO>, "queryKey">,
) {
  return useQuery({
    queryKey: reportQueryKeys.lead({
      leadStatusList,
      leadSourceList,
      page,
      limit,
      sort,
    }),
    queryFn: async () => {
      return (
        await api.leadApi.openReport({
          leadStatusList,
          leadSourceList,
          page,
          limit,
          sort,
        })
      ).data;
    },
    placeholderData: () => {
      return {
        leadReportByOpenStatusViewDTO: defaultPage<LeadReportItemDTO>(),
        leadReportTotal: 0,
      };
    },
    select: (data) => {
      const dto = merge({}, data.leadReportByOpenStatusViewDTO, {
        content: data.leadReportByOpenStatusViewDTO.content.map(
          ({ createdDate, ...rest }) => {
            return {
              createdDate: createdDate && utcToZonedTime(createdDate, tz),
              ...rest,
            };
          },
        ),
      });
      return {
        ...data,
        leadReportByOpenStatusViewDTO: dto,
      };
    },
    enabled: !!tz,
    ...queryOpts,
  });
}
